import { gql } from '@edreamsodigeo/frontend-api-client';

const universalShoppingBasketBreakdownItemFragment = gql`
  fragment UniversalShoppingBasketBreakdownItemFields on ShoppingBasketPriceBreakdownItem {
    priceConcept
    price {
      amount {
        amount
        currency
      }
    }
  }
`;

const universalShoppingBasketPriceFragment = gql`
  fragment UniversalShoppingBasketPriceFields on ShoppingBasketPrice {
    amount {
      amount
      currency
    }
    breakdown {
      items {
        ...UniversalShoppingBasketBreakdownItemFields
      }
    }
  }
  ${universalShoppingBasketBreakdownItemFragment}
`;

const universalPriceBreakdownByProductTypeFragment = gql`
  fragment UniversalPriceBreakdonByProductTypeFields on UniversalShoppingBasketProductTypePriceBreakdown {
    productType
    products {
      productId {
        id
        type
      }
      price {
        ...UniversalShoppingBasketPriceFields
      }
    }
    price {
      ...UniversalShoppingBasketPriceFields
    }
  }
`;

const universalPriceBreakdownByBundleTypeFragment = gql`
  fragment UniversalPriceBreakdownByBundleTypeFields on UniversalShoppingBasketBundleTypePriceBreakdown {
    bundleType
    bundles {
      bundleId {
        id
        type
      }
      price {
        ...UniversalShoppingBasketPriceFields
      }
    }
    price {
      ...UniversalShoppingBasketPriceFields
    }
  }
`;

export const universalPriceBreakdownFragment = gql`
  fragment UniversalPriceBreakdownFields on UniversalShoppingBasketPriceBreakdown {
    priceBreakDownByProductType {
      ...UniversalPriceBreakdonByProductTypeFields
    }
    priceBreakDownByBundleType {
      ...UniversalPriceBreakdownByBundleTypeFields
    }
    price {
      ...UniversalShoppingBasketPriceFields
    }
  }
  ${universalPriceBreakdownByProductTypeFragment}
  ${universalPriceBreakdownByBundleTypeFragment}
  ${universalShoppingBasketPriceFragment}
`;
